import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

const defaultValues = {
  tituloWeb: '',
  primaryColor: '',
  secondaryColor: '',
};

const hexadecimalRegex = /^#?([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/;

const resolver = yupResolver(
  yup.object().shape({
    tituloWeb: yup.string(),
    primaryColor: yup
      .string()
      .matches(hexadecimalRegex, { message: 'Debe ser un color hexadecimal válido', excludeEmptyString: true }),
    secondaryColor: yup
      .string()
      .matches(hexadecimalRegex, { message: 'Debe ser un color hexadecimal válido', excludeEmptyString: true }),
  })
);

export { defaultValues, resolver };
